/**
 * Resolves the API Base URL dynamically.
 * 1. Checks build-time environment variable VITE_API_BASE_URL from .env
 * 2. If empty in browser, automatically derives production backend URL based on hostname
 */
function resolveApiBaseUrl(): string {
  const envUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;

    if (host === 'cgworkflow.com' || host === 'www.cgworkflow.com') {
      return 'https://api.cgworkflow.com';
    }
  }

  return '';
}

export const API_BASE_URL = resolveApiBaseUrl();
